import React from "react";
import AppTemplate from "../components/PlanSelectConfirm";

const PlanSelectConfirm: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default PlanSelectConfirm;
